<template>
  <div class="container-fluid">
    <section class="row">
      <div>
        <div class="mt-3 text-center">
          <img src="../assets/join_car.png" class="w-50"/>
        </div>
        <p class="text-center fs-title fw-bold mb-0">환영합니다! :)</p>
        <p class="text-center fs-2 fw-bold">가입 신청이 완료 되었습니다.</p>
        <p class="text-center fs-5 fw-bold">
          담당 직원이 연락드릴 예정입니다
        </p>
        <p class="text-center fs-5 fw-bold">
          아래의 서류들을 미리 제출하시면<br/>
          좀 더 빠른 어플 사용이 가능합니다.
        </p>
      </div>
    </section>
    <footer class="footer d-flex flex-column mt-3 d-flex gap-1">
      <button class="btn btn-primary col-12 rounded-pill" @click="moveAttach">서류 제출하기</button>
      <button class="btn btn-outline-primary col-12 rounded-pill" @click="moveAfter">다음에 하기</button>
    </footer>

  </div>
</template>

<script>

/**
 * 간편회원가입 - 가입 완료페이지
 */
export default {
  name: "CompletionScreenDefault",
  data(){
    return {
      iv: this.$CryptoJS.enc.Hex.parse('0000000000000000'),
      key: this.$CryptoJS.enc.Utf8.parse('alkdjalsdjivlake'),
    }
  },
  methods:{
    moveAfter(){

      let isMancharo = this.$store.getters.getJoinUrl;

      let url = "https://www.2424-2424.com";
      if(isMancharo == 'mancharo') {
        url = "https://mancharo.com/";
      }
      // this.sendAttachLink()
      window.location.href = url;
    },
    moveAttach(){
      this.$emit('current-page',{ page:'att' });
    },
    sendAttachLink(){
      //필요한 정보 memberSeq
      let userSeq = this.$store.getters.getUserSeq;
      let mobile = this.$store.getters.getMemberInfo.mobile;
      let gradeCode = this.$store.getters.getGradeCode;

      if(this.isEmpty(userSeq)){
        this.$swal.fire({title:'입력된 번호가 없습니다.'});
        return;
      }
      userSeq = String(this.$store.getters.getUserSeq);

      const result = this.$CryptoJS.AES.encrypt(
          //주민번호 뒷자리 암호화
          userSeq,
          this.key,
          {
            iv: this.iv,
            mode: this.$CryptoJS.mode.CBC,
            keySize: 256 / 32,
            padding: this.$CryptoJS.pad.Pkcs7,
          },
      ).toString();

      const param = {
        pass_code: result,     // 암호화 코드
        mobile: mobile,        // 핸드폰 번호
        option: "optAttach",   // 템플릿 옵션명
        grade_code: gradeCode, // 멤버 그룹 번호
        etc_info: "간편회원가입" // 메세지 분류
      };

      this.$http.post('/api/simplejoin/mms',param);
    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
  },
}
</script>

<style scoped>

</style>